import { call, put, takeEvery } from 'redux-saga/effects';
import {
  UpdateProgramSlotApi,
  UpdateTreatmentSlotApi,
  getAllProgramSlotApi,
  getAllTreatmentSlotApi,
  getProgramSlotByIdApi,
  getTreatmentSlotByIdApi
} from '../../utils/api';
import {
  ActionGetProgramSlotByIdSuccess,
  ActionGetTreatmentSlotByIdSuccess,
  GetAllTreatmentSlotSuccess,
} from '../Actions/TreatmentSlotAction';
import {
  GET_ALL_PROGRAM_SLOT,
  GET_ALL_TREATMENT_SLOT,
  GET_PROGRAM_SLOT_BY_ID,
  GET_TREATMENT_SLOT_BY_ID,
  UPDATE_PROGRAM_SLOT,
  UPDATE_TREATMENT_SLOT,
} from '../storeTypes';
import { handleApiResponse } from '../../utils/functions';

function* getAllTreatmentSlotSaga(action) {
  try {
    const response = yield call(getAllTreatmentSlotApi, action.payload);
    if (response?.status === 200) {
      yield put(GetAllTreatmentSlotSuccess(response?.data?.data));
      // Call the callback with the response data if provided
      if (action?.callBack) {
        action?.callBack(response?.data?.data?.[0]);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
    // Call the callback with null/empty on error
    if (action?.callBack) {
      action?.callBack(null);
    }
  }
}

function* getAllProgramSlotSaga(action) {
  try {
    const response = yield call(getAllProgramSlotApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetProgramSlotByIdSuccess(response?.data?.data));
      // Call the callback with the response data if provided
      if (action?.callBack) {
        action?.callBack(response?.data?.data?.[0]);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
    // Call the callback with null/empty on error
    if (action?.callBack) {
      action?.callBack(null);
    }
  }
}

function* GetProgramSlotByIdSaga(action) {
  try {
    const response = yield call(getProgramSlotByIdApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetProgramSlotByIdSuccess(response?.data?.data));
      // Call the callback if provided
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}


function* GetTreatmentSlotByIdSaga(action) {
  try {
    const response = yield call(getTreatmentSlotByIdApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetTreatmentSlotByIdSuccess(response?.data?.data));
      // Call the callback if provided
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}
function* UpdateTreatmentSlotSaga(action) {
  try {
    const response = yield call(UpdateTreatmentSlotApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* UpdateProgramSlotSaga(action) {
  try {
    const response = yield call(UpdateProgramSlotApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

export function* TreatmentSlotSaga() {
  [
    yield takeEvery(GET_ALL_TREATMENT_SLOT, getAllTreatmentSlotSaga),
    yield takeEvery(GET_TREATMENT_SLOT_BY_ID, GetTreatmentSlotByIdSaga),
    yield takeEvery(UPDATE_TREATMENT_SLOT, UpdateTreatmentSlotSaga),
    yield takeEvery(GET_ALL_PROGRAM_SLOT, getAllProgramSlotSaga),
    yield takeEvery(GET_PROGRAM_SLOT_BY_ID, GetProgramSlotByIdSaga),
    yield takeEvery(UPDATE_PROGRAM_SLOT, UpdateProgramSlotSaga),

  ];
}
